/**
 * Composition root for the iframe app.
 *
 * The whole of this file is deliberately boring, because the interesting decision
 * was made before it ran: this document is served from the WIDGET origin, and the
 * loader refused to create the frame at all if that origin was the customer's.
 * Everything below therefore executes in a place where an XSS costs us our own
 * origin and nobody else's.
 */
import { createApp } from 'vue';

import '@axon/tokens/tokens.css';
import '../styles/widget.css';

import { readBootParams } from './boot';
import WidgetRoot from './WidgetRoot.vue';
import UnavailableNotice from '../screens/UnavailableNotice.vue';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('index.html is missing #root; the widget has nowhere to mount');
}

const boot = readBootParams(window.location.search);

if (boot.ok) {
  createApp(WidgetRoot, { params: boot.params }).mount(container);
} else {
  // No public key means no tenant, no brand and no configuration: there is
  // nothing to ask the API for and nothing to render but an explanation. It is
  // rendered rather than thrown because the visitor did not do anything wrong and
  // an empty box would look like our software crashed on the customer's site.
  //
  // Untranslated on purpose — the locale is negotiated against the brand's
  // staffed languages, and without a key there is no brand. This copy is the one
  // string in the app aimed at whoever installed the widget, not at a visitor.
  createApp(UnavailableNotice, {
    detail: 'Missing data-omni-key on the loader script tag.',
  }).mount(container);
}
